export default __webpack_public_path__ + "static/media/marble.ff75b3be.png";